import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'removeHttp'
})
export class RemoveHttpPipe implements PipeTransform {
  transform(value: string): string {
    const baseDomain = environment.flightConfig.apiUrl;
    if (!value) return value;
    if (value.startsWith('http://') || value.startsWith('https://')) return value;
    return value.includes(baseDomain) ? value : `${baseDomain}${value.replace(/^\/+/, '')}`;
    }
}
